import { getNearestFeature, getNearestFeatures } from "@l2r-front/l2r-geodata"

import { useImageCollectionStateContext } from "../../../contexts/ImageCollectionContext"

import { useImageCollection } from "./useImageCollection"
import { usePhotos } from "./usePhoto"

export function useNearestImageInCollection(imageCollection, road, position, maxDistance = 0.02) {
    const {
        data: collectionLayer,
        isLoading,
        isError,
    } = useImageCollection(imageCollection, { linear_location_road: road })

    const imageFeature = getNearestFeature(collectionLayer, position, maxDistance)

    return { imageFeature, isLoading, isError }
}

function useNearestImagesInCollection(imageCollection, road, position, radius = 0.02) {
    const {
        data: collectionLayer,
        isLoading,
        isError,
    } = useImageCollection(imageCollection, { linear_location_road: road })

    const imageFeatures = getNearestFeatures(collectionLayer, position, radius)

    return { imageFeatures, isLoading, isError }
}

export function useDownloadNearbyImages(position, radius = 0.02) {
    const { imageCollection, selectedImageCollectionRoad } = useImageCollectionStateContext()

    const { imageFeatures } = useNearestImagesInCollection(imageCollection, selectedImageCollectionRoad, position, radius)
    const results = usePhotos(imageFeatures?.map(imageFeature => imageFeature.id), { enabled: !!imageFeatures?.length })

    return results
}